module.exports = __webpack_public_path__ + "img/DOLLAR_SIGN.76f4208f.svg";